export default "__VITE_ASSET__COSF62fL__"